document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-image-banner').forEach(function (section) {
    var viewport = section.querySelector('[data-banner-viewport]');
    var track = section.querySelector('[data-banner-track]');
    var slides = section.querySelectorAll('.custom-image-banner__slide');
    var prevBtn = section.querySelector('[data-banner-prev]');
    var nextBtn = section.querySelector('[data-banner-next]');
    var dots = section.querySelectorAll('[data-banner-dot]');
    var total = slides.length;

    if (!viewport || !track || total === 0) return;

    var current = 0;
    var isAnimating = false;
    var autoplayTimer = null;
    var autoplaySeconds = parseFloat(section.getAttribute('data-autoplay-speed') || '0');

    function setSlideWidths() {
      var w = viewport.clientWidth;
      track.style.width = (w * total) + 'px';
      section.querySelectorAll('.custom-image-banner__slide').forEach(function (slide) {
        slide.style.width = w + 'px';
      });
      return w;
    }

    function setViewportHeight(activeNode) {
      if (activeNode && activeNode.offsetHeight > 0) {
        viewport.style.height = activeNode.offsetHeight + 'px';
      }
    }

    function updateActiveClasses(targetIndex) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-banner-slide') === String(targetIndex));
      });
      dots.forEach(function (dot) {
        dot.classList.toggle('is-active', dot.getAttribute('data-banner-dot') === String(targetIndex));
      });
    }

    // Always animates as a single forward (left) slide, so new content
    // consistently enters from the right — regardless of whether the
    // logical direction is "next", "prev", or jumping to an arbitrary dot.
    function goTo(targetIndex) {
      if (isAnimating) return;
      targetIndex = ((targetIndex % total) + total) % total;
      if (targetIndex === current) return;

      var targetNode = track.querySelector('[data-banner-slide="' + targetIndex + '"]');
      var currentNode = track.querySelector('[data-banner-slide="' + current + '"]');
      if (!targetNode || !currentNode) return;

      isAnimating = true;

      var w = setSlideWidths();

      // Place the target slide immediately to the right of the current one
      track.style.transition = 'none';
      track.insertBefore(targetNode, currentNode.nextSibling);
      track.style.transform = 'translateX(0px)';
      void track.offsetWidth; // force reflow before re-enabling transition

      track.style.transition = '';
      requestAnimationFrame(function () {
        track.style.transform = 'translateX(-' + w + 'px)';
        setViewportHeight(targetNode);
      });

      function onTransitionEnd(e) {
        if (e.propertyName !== 'transform') return;
        track.removeEventListener('transitionend', onTransitionEnd);

        // Snap back to a clean position 0 with the target slide as the
        // true first child, ready for the next transition.
        track.style.transition = 'none';
        track.insertBefore(targetNode, track.firstChild);
        track.style.transform = 'translateX(0px)';
        void track.offsetWidth;
        track.style.transition = '';

        current = targetIndex;
        updateActiveClasses(current);
        isAnimating = false;
      }

      track.addEventListener('transitionend', onTransitionEnd);
    }

    function next() {
      goTo(current + 1);
    }
    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (autoplaySeconds > 0 && total > 1) {
        autoplayTimer = setInterval(next, autoplaySeconds * 1000);
      }
    }
    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        stopAutoplay();
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        stopAutoplay();
        startAutoplay();
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-banner-dot'), 10));
        stopAutoplay();
        startAutoplay();
      });
    });

    // Initial setup: size everything, show slide 0 with no animation
    track.style.transition = 'none';
    var initialW = setSlideWidths();
    track.style.transform = 'translateX(0px)';
    void track.offsetWidth;
    track.style.transition = '';

    var initialActive = track.querySelector('[data-banner-slide="0"]');
    setViewportHeight(initialActive);

    var images = track.querySelectorAll('img');
    var pending = images.length;
    function onImageDone() {
      pending--;
      if (pending <= 0) setViewportHeight(track.querySelector('[data-banner-slide="' + current + '"]'));
    }
    if (pending > 0) {
      images.forEach(function (img) {
        if (img.complete) {
          onImageDone();
        } else {
          img.addEventListener('load', onImageDone, { once: true });
          img.addEventListener('error', onImageDone, { once: true });
        }
      });
    }

    window.addEventListener('load', function () {
      setSlideWidths();
      setViewportHeight(track.querySelector('[data-banner-slide="' + current + '"]'));
    });
    setTimeout(function () {
      setSlideWidths();
      setViewportHeight(track.querySelector('[data-banner-slide="' + current + '"]'));
    }, 600);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        track.style.transition = 'none';
        setSlideWidths();
        track.style.transform = 'translateX(0px)';
        void track.offsetWidth;
        track.style.transition = '';
        setViewportHeight(track.querySelector('[data-banner-slide="' + current + '"]'));
      }, 150);
    });

    if (total > 1) {
      startAutoplay();
    }
  });
});